import './PlsWait.scss';

import React from 'react';

import VerticalCenter from '../../../elements/VerticalCenter';
import liveVotingCommonScreen from '../common/LiveVotingScreenHOC';

class PlsWaitScreen extends React.Component {
    render() {
        let {event, question, i18n} = this.props

        return (
            <div
                className="fill-container PlsWaitScreen"
                style={{
                    backgroundImage: 'url('+this.props.resPath+'img/live_vote_horses.png)',
                    backgroundSize: 'cover',
                }}>
                <VerticalCenter>
                    <div className="content text-center well">
                        <h3>{i18n['livevoting.desc-vote-close']}</h3>
                    </div>
                </VerticalCenter>
            </div>
        );
    }
}
export default liveVotingCommonScreen(PlsWaitScreen);
